import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-full relative" }
const _hoisted_2 = { class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { class: "relative z-50" }
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]

import { ref, reactive, computed, onMounted } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { DynamicProperty, RadioItem, MetaData } from "@/models/dtos";
import InputRadio from "./InputRadio.vue";
import { useStore } from "vuex";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputRadioGroup',
  props: {
  model: {
    type: Object as () => DynamicProperty,
    required: true,
  },
  placeholder: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const radioButtons = reactive([] as RadioItem[]);
const withoutGroup = computed(() =>
  radioButtons.filter((px) => px.item.type !== "radioGroup")
);

const props = __props;

let model = ref(props.model);

const selectedKey = ref("");

onMounted(() => {
  let properties = (model.value.data.metadata as MetaData).properties.filter(
    (x) => props.model.data.keys.includes(x.key)
  );
  properties.forEach((x) => {
    radioButtons.push(new RadioItem(x, x.label, x.data));
  });

  let selected = radioButtons.find((x) => x.value)?.item?.key;

  if (selected) {
    selectedKey.value = selected;
  }
});

const store = useStore();

function onChange(item: DynamicProperty) {
  selectedKey.value = item.key;
  store.dispatch("formbuilder/selectRadioButton", {
    parentKey: model.value.key,
    keyToSelect: item.key,
    adminView: props.adminView,
  });
}

const showingErrorMessage = ref(false);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};
const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(model).label), 1),
    _createElementVNode("div", {
      id: 'icon-error_' + _unref(model).key,
      class: "hidden absolute top-[3px] right-0 left-auto w-[20px] flex flex-row justify-center items-center",
      onMouseenter: showErrorMessage,
      onMouseleave: hideErrorMessage
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("i", { class: "text-red-2 fa-solid fa-circle-info" }, null, -1)
    ]))], 40, _hoisted_3),
    _createElementVNode("fieldset", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(withoutGroup.value, (item) => {
          return (_openBlock(), _createBlock(InputRadio, {
            key: item.item.key,
            model: item.item,
            disabled: props.disabled || (__props.adminView && !__props.editMode),
            isSelected: item.item.key === selectedKey.value,
            onChange: () => onChange(item.item)
          }, null, 8, ["model", "disabled", "isSelected", "onChange"]))
        }), 128))
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md",
        id: 'outer-error_' + _unref(model).key
      }, [
        _createElementVNode("p", {
          class: "font-medium text-sm text-red-2",
          id: 'error_' + _unref(model).key
        }, null, 8, _hoisted_8)
      ], 8, _hoisted_7)
    ], 512), [
      [_vShow, showingErrorMessage.value]
    ])
  ]))
}
}

})